export default __webpack_public_path__ + "static/media/xamarin-seeklogo.com.f841b52f.svg";